import { createWlinkI18n } from "@wlink/commons/i18n";
const i18n = createWlinkI18n();
const { t } = i18n.global;
// KYC相关选项配置
export const gender = [
  { label: t("61180"), value: "male" },
  { label: t("61181"), value: "female" },
];

export const identification_type = [
  // 护照
  { label: t("61437"), value: "passport" },
  // 身份证
  { label: t("61436"), value: "identity_card" },
  // 驾照
  { label: t("61438"), value: "driver_license" },
  // 医保卡
  { label: t("61439"), value: "medical_insurance" },
  // 居住证
  { label: t("63406"), value: "residence_permit" },
  // 永居卡
  { label: t("63407"), value: "permanent_card" },
];

export const annual_income = [
  // 高于 $10,000,000 美元
  { label: t("61602", ["$10,000,000"]), value: "more_than_10_million" },
  // $5,000,000 - $10,000,000 美元
  {
    label: t("61603", ["$5,000,000", "$10,000,000"]),
    value: "5_to_10_million",
  },
  // $1,000,000 - $5,000,000 美元
  {
    label: t("61603", ["$1,000,000", "$5,000,000"]),
    value: "1_to_5_million",
  },
  // $500,000 - $1,000,000 美元
  {
    label: t("61603", ["$500,000", "$1,000,000"]),
    value: "500k_to_1_million",
  },
  // $100,000 - $500,000 美元
  { label: t("61603", ["$10,000", "$500,000"]), value: "100k_to_500k" },
  // 低于 $100,000 美元
  { label: t("61604", ["$100,000"]), value: "less_than_100k" },
];

export const investment_amount = [
  // 高于 $10,000,000 美元
  { label: t("61602", ["$10,000,000"]), value: "more_than_10_million" },
  // $5,000,000 - $10,000,000 美元
  {
    label: t("61603", ["$5,000,000", "$10,000,000"]),
    value: "5_to_10_million",
  },
  // $1,000,000 - $5,000,000 美元
  {
    label: t("61603", ["$1,000,000", "$5,000,000"]),
    value: "1_to_5_million",
  },
  // 低于 $1,000,000 美元
  { label: t("61604", ["$1,000,000"]), value: "less_than_1_million" },
];

export const investment_duration = [
  // 超过5年
  { label: t("62654"), value: "more_than_5_years" },
  // 3-5年
  { label: t("62653", ["3-5"]), value: "3_to_5_years" },
  // 1-3年
  { label: t("62653", ["1-3"]), value: "1_to_3_years" },
  // 少于1年
  { label: t("62655"), value: "less_than_1_year" },
  // 无投资经验
  { label: t("63408"), value: "no_trading_experience" },
];

export const investment_product = [
  // 股票
  { label: t("62676"), value: "stocks" },
  // 基金
  { label: t("62677"), value: "funds" },
  // 债券
  { label: t("62678"), value: "bonds" },
  // 期货
  { label: t("62679"), value: "futures" },
  // 外汇
  { label: t("62680"), value: "forex" },
  // 加密货币
  { label: t("62681"), value: "cryptocurrency" },
  // 其他
  { label: t("61435"), value: "other" },
];

export const investment_goal = [
  // 资本增值(高风险高回报)
  { label: t("62682"), value: "capital_appreciation" },
  // 稳健增长(平衡风险与回报)
  { label: t("62683"), value: "stable_growth" },
  // 保本保值(低风险)
  { label: t("62684"), value: "capital_preservation" },
  // 不确定
  { label: t("62685"), value: "uncertain" },
];

export const marital_status = [
  { label: t("61410"), value: "single" },
  { label: t("61411"), value: "married" },
  { label: t("61412"), value: "divorced" },
  { label: t("61413"), value: "widowed" },
];

export const relationshipOptions = [
  // 配偶
  { label: t("61419"), value: "配偶" },
  // 父母
  { label: t("61418"), value: "父母" },
  // 子女
  { label: t("61420"), value: "子女" },
  // 兄弟姐妹
  { label: t("62657"), value: "兄弟姐妹" },
  // 朋友
  { label: t("61421"), value: "朋友" },
  // 同事
  { label: t("62658"), value: "同事" },
  // 监护人
  { label: t("62659"), value: "监护人" },
  // 其他
  { label: t("61435"), value: "其他" },
];

export const industryTypeOptions = [
  // 金融 / 投资
  { label: t("62661"), value: "金融 / 投资" },
  // 信息技术 / 软件开发
  { label: t("62662"), value: "信息技术 / 软件开发" },
  // 制造业 / 工业
  { label: t("62663"), value: "制造业 / 工业" },
  // 教育 / 培训
  { label: t("62664"), value: "教育 / 培训" },
  // 医疗 / 健康
  { label: t("62665"), value: "医疗 / 健康" },
  // 政府 / 公共服务
  { label: t("62666"), value: "政府 / 公共服务" },
  // 法律 / 律师
  { label: t("62667"), value: "法律 / 律师" },
  // 交通 / 物流
  { label: t("62668"), value: "交通 / 物流" },
  // 酒店 / 餐饮 / 旅游
  { label: t("62669"), value: "酒店 / 餐饮 / 旅游" },
  // 建筑 / 房地产
  { label: t("62670"), value: "建筑 / 房地产" },
  // 零售 / 批发
  { label: t("62671"), value: "零售 / 批发" },
  // 农业 / 畜牧 / 渔业
  { label: t("62672"), value: "农业 / 畜牧 / 渔业" },
  // 能源 / 化工
  { label: t("62673"), value: "能源 / 化工" },
  // 媒体 / 广告 / 出版
  { label: t("62674"), value: "媒体 / 广告 / 出版" },
  // 无业 / 自由职业
  { label: t("62675"), value: "无业 / 自由职业" },
  // 退休
  { label: t("61598"), value: "退休" },
  // 学生
  { label: t("61599"), value: "学生" },
  // 其他
  { label: t("61435"), value: "其他" },
];

export const verificationResultOptions = [
  // 待处理
  { label: t("62352"), value: "pending" },
  // 已批准
  { label: t("61307"), value: "approved" },
  // 已拒绝
  { label: t("61278"), value: "disapproved" },
];

export const verificationMethodOptions = [
  // 手动验证
  { label: t("61273"), value: "manual" },
];

// 根据key获取对应的选项映射
export function getOptionsByKey(key: string) {
  const optionsMap: Record<string, any[]> = {
    gender: gender,
    identification_type: identification_type,
    annual_income: annual_income,
    investment_amount: investment_amount,
    investment_duration: investment_duration,
    investment_product: investment_product,
    investment_goal: investment_goal,
    marital_status: marital_status,
    emergency_contact_relationship: relationshipOptions,
    industry_attributes: industryTypeOptions,
  };
  return optionsMap[key] || [];
}

// 根据value查找对应的中文label
export function getLabelByValue(key: string, value: string | number): string {
  const options = getOptionsByKey(key);
  const option = options.find((opt) => opt.value === value);
  return option ? option.label : String(value);
}
